let featuredBlogSlider = $('.featured-blog-slider');

$(featuredBlogSlider).flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: (window.innerWidth >= 750) ? 'center' : 'left',
    wrapAround: true,
    pageDots: (window.innerWidth >= 750) ? false : true,
    contain: true,
    prevNextButtons: false,
    initialIndex: 0,
    arrowShape: arrowShape,
    freeScroll: false,
    on: {
    ready: function() {
        // Resize flickity when the slider is settled
        $(featuredBlogSlider).on( 'settle.flickity', function() {
            $(featuredBlogSlider).flickity('resize')
        });
    }
    }
});